module.exports = __webpack_public_path__ + "img/three2Orange.24f445ce.png";